module.exports = __webpack_public_path__ + "img/ug.278e456.svg";